// Modal Content, This content is mainly used for Modal wrap with MainModal.tsx Component
import React from "react";
import { InputField } from "./InputField";
import PrimaryButton from "./PrimaryButton";
import { ActionBothProps } from "../types/common";

const EnterNewEmailModal: React.FC<ActionBothProps> = ({showPrev, showNext}) => {
  return (
    <>
      <p className="text-[#9392A2] text-sm font-medium leading-snug tracking-tight mt-1 mb-4">Provide us new email to use <br /> it as a basis for your account.</p>
      <InputField label="New email" className="mb-4" />
      <div className="flex items-center gap-2">
        <PrimaryButton onClick={() => showPrev && showPrev()} label="Back" className="py-2 w-full rounded-3xl" black />
        <PrimaryButton onClick={() => showNext && showNext()} label="Proceed" className="py-2 w-full rounded-3xl" />
      </div>
    </>
  );
};

export default EnterNewEmailModal;